import { AppSkeleton } from './AppSkeleton'

/**
 * TableSkeleton — Reusable Skeleton for Tables & List Rows
 *
 * @param {object} props
 * @param {number} [props.rows=5]
 * @param {number} [props.columns=4]
 */
export function TableSkeleton({ rows = 5, columns = 4 }) {
  return (
    <div className="flex w-full flex-col gap-3">
      {/* Table Header */}
      <div className="flex gap-4 border-b border-surface-variant/30 pb-3">
        {Array.from({ length: columns }).map((_, c) => (
          <AppSkeleton key={c} width={`${100 / columns}%`} height="14px" />
        ))}
      </div>

      {/* Table Rows */}
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 py-2.5">
          {Array.from({ length: columns }).map((_, c) => (
            <AppSkeleton
              key={c}
              width={c === 0 ? '70%' : `${90 / columns}%`}
              height="16px"
              className={c === 0 ? 'font-bold' : ''}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default TableSkeleton
